import React from 'react'
import logo from '../../assets/svg/logo.svg'
import { NavLink, Link } from 'react-router-dom'
import { Link as ScrolLink } from 'react-scroll'
import './Navbar.css'

const Navbar = () => {
    return (
        <header>
                <div id="container" className="header">
                    <div className="logo">
                        <Link exact="true" to="/"><img src={logo} alt="Logo" /></Link>
                    </div>
                    <nav className="navbar">
                        <ul>
                            <li><NavLink exact to="/">Home</NavLink></li>
                            <li>
                                {/* eslint-disable */}
                                <ScrolLink to="portfolio" smooth={true} duration={300} offset={0}>
                                    <Link exact="true" to="/">
                                        Portfolio
                                    </Link>
                                </ScrolLink>
                            </li>
                            <li>
                                <ScrolLink to="testimonials" smooth={true} duration={400} offset={-60}>
                                    <Link exact="true" to="/">
                                        Testimonials
                                    </Link>
                                </ScrolLink>
                            </li>
                            <li><NavLink to="/about">About</NavLink></li>
                            <li><NavLink to="/contact">Contact</NavLink></li>
                        </ul>
                    </nav>
                </div>
        </header>
    )
}

export default Navbar
